/**
 * Page de secours /demo-requise (accès direct). Le cas normal est l'overlay
 * flouté affiché par AppShell par-dessus le tableau de bord (voir AppShell).
 */
import { Navigate } from "react-router";
import { useAuth } from "../../auth/AuthContext";
import { Logo } from "../../ui/Logo";
import { DemoRequiseCard } from "./DemoRequiseCard";

export function DemoRequiseGatePage() {
  const { status, demoRequired } = useAuth();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <Logo size={48} />
      </div>
    );
  }
  if (status === "anonymous") return <Navigate to="/login" replace />;
  if (!demoRequired) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-50 px-4 py-10">
      <DemoRequiseCard />
    </div>
  );
}
